export { default } from './LabResultsSection';
